/* eslint-disable react-hooks/exhaustive-deps */
import axios, { CancelTokenSource } from 'axios'
import { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useResetStateOnDismount from 'shared/hooks/useResetStateOnDismount'

import { getActiveClient } from 'shared/store/clients/selectors'

import {
  fetchRecipientsObjectAndMetersTypesRequest,
  fetchRecipientsRequest,
  resetRecipients,
} from 'shared/store/sendMessage/recipients'
import { getMessageRecipients } from 'shared/store/sendMessage/recipients/selectors'
import { FilterTypeEnum } from '../models/Recipients'

const useInitRecipientsModal = () => {
  const client = useSelector(getActiveClient)
  const dispatch = useDispatch()
  const { filters } = useSelector(getMessageRecipients)
  const [source, setSource] = useState<CancelTokenSource>()

  useResetStateOnDismount(resetRecipients.type)

  const filterTypeRef = useRef({
    type: filters.filterType,
    board: filters.boardId,
    client: client?.id,
  })

  const isOnSameClient = client?.id === filterTypeRef.current.client
  const isSameFilterType = filters.filterType === filterTypeRef.current.type
  const isSameBoard = filters.boardId === filterTypeRef.current.board
  const isTypeBoardMembers = filters.filterType === FilterTypeEnum.BoardMembers

  const isMeterAndObjectsNull =
    filters.meterTypeNo === null && filters.objectTypeNo === null

  useEffect(() => {
    if (!isMeterAndObjectsNull) return
    dispatch(fetchRecipientsObjectAndMetersTypesRequest())
  }, [])

  useEffect(() => {
    // Only fetch recipients when the modal opens
    if (source) source.cancel()
    const tokenSource = axios.CancelToken.source()
    setSource(tokenSource)

    // Avoids refetch of board members (non-paginated list)
    if (isOnSameClient && isSameFilterType && isSameBoard && isTypeBoardMembers)
      return

    if (isMeterAndObjectsNull) return

    dispatch(fetchRecipientsRequest(tokenSource))

    // Updates the ref to handle the case when the user changes the filter
    filterTypeRef.current = {
      type: filters.filterType,
      board: filters.boardId,
      client: client?.id,
    }
  }, [filters, client?.id, dispatch])

  return
}

export default useInitRecipientsModal
